import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import des traductions FR
import frCommon from './locales/fr/common.json';
import frIntro from './locales/fr/intro.json';
import frMeasurements from './locales/fr/measurements.json';
import frPhoneAuth from './locales/fr/phoneAuth.json';
import frSaveAccount from './locales/fr/saveAccount.json';
import frResults from './locales/fr/results.json';
import frClothingSizes from './locales/fr/clothingSizes.json';
import frSelfie from './locales/fr/selfie.json';
import frCacheModal from './locales/fr/cacheModal.json';

// Import des traductions EN
import enCommon from './locales/en/common.json';
import enIntro from './locales/en/intro.json';
import enMeasurements from './locales/en/measurements.json';
import enPhoneAuth from './locales/en/phoneAuth.json';
import enSaveAccount from './locales/en/saveAccount.json';
import enResults from './locales/en/results.json';
import enClothingSizes from './locales/en/clothingSizes.json';
import enSelfie from './locales/en/selfie.json';
import enCacheModal from './locales/en/cacheModal.json';

// Import des traductions ES
import esCommon from './locales/es/common.json';
import esIntro from './locales/es/intro.json';
import esMeasurements from './locales/es/measurements.json';
import esPhoneAuth from './locales/es/phoneAuth.json';
import esSaveAccount from './locales/es/saveAccount.json';
import esResults from './locales/es/results.json';
import esClothingSizes from './locales/es/clothingSizes.json';
import esSelfie from './locales/es/selfie.json';
import esCacheModal from './locales/es/cacheModal.json';

// Import des traductions PT
import ptCommon from './locales/pt/common.json';
import ptIntro from './locales/pt/intro.json';
import ptMeasurements from './locales/pt/measurements.json';
import ptPhoneAuth from './locales/pt/phoneAuth.json';
import ptSaveAccount from './locales/pt/saveAccount.json';
import ptResults from './locales/pt/results.json';
import ptClothingSizes from './locales/pt/clothingSizes.json';
import ptSelfie from './locales/pt/selfie.json';
import ptCacheModal from './locales/pt/cacheModal.json';

// Import des traductions IT
import itCommon from './locales/it/common.json';
import itIntro from './locales/it/intro.json';
import itMeasurements from './locales/it/measurements.json';
import itPhoneAuth from './locales/it/phoneAuth.json';
import itSaveAccount from './locales/it/saveAccount.json';
import itResults from './locales/it/results.json';
import itClothingSizes from './locales/it/clothingSizes.json';
import itSelfie from './locales/it/selfie.json';
import itCacheModal from './locales/it/cacheModal.json';

// Import des traductions ZH (Mandarin)
import zhCommon from './locales/zh/common.json';
import zhIntro from './locales/zh/intro.json';
import zhMeasurements from './locales/zh/measurements.json';
import zhPhoneAuth from './locales/zh/phoneAuth.json';
import zhSaveAccount from './locales/zh/saveAccount.json';
import zhResults from './locales/zh/results.json';
import zhClothingSizes from './locales/zh/clothingSizes.json';
import zhSelfie from './locales/zh/selfie.json';
import zhCacheModal from './locales/zh/cacheModal.json';

// Import des traductions JA (Japonais)
import jaCommon from './locales/ja/common.json';
import jaIntro from './locales/ja/intro.json';
import jaMeasurements from './locales/ja/measurements.json';
import jaPhoneAuth from './locales/ja/phoneAuth.json';
import jaSaveAccount from './locales/ja/saveAccount.json';
import jaResults from './locales/ja/results.json';
import jaClothingSizes from './locales/ja/clothingSizes.json';
import jaSelfie from './locales/ja/selfie.json';
import jaCacheModal from './locales/ja/cacheModal.json';

// Import des traductions HI (Hindi)
import hiCommon from './locales/hi/common.json';
import hiIntro from './locales/hi/intro.json';
import hiMeasurements from './locales/hi/measurements.json';
import hiPhoneAuth from './locales/hi/phoneAuth.json';
import hiSaveAccount from './locales/hi/saveAccount.json';
import hiResults from './locales/hi/results.json';
import hiClothingSizes from './locales/hi/clothingSizes.json';
import hiSelfie from './locales/hi/selfie.json';
import hiCacheModal from './locales/hi/cacheModal.json';

const resources = {
  fr: {
    common: frCommon,
    intro: frIntro,
    measurements: frMeasurements,
    phoneAuth: frPhoneAuth,
    saveAccount: frSaveAccount,
    results: frResults,
    clothingSizes: frClothingSizes,
    selfie: frSelfie,
    cacheModal: frCacheModal,
  },
  en: {
    common: enCommon,
    intro: enIntro,
    measurements: enMeasurements,
    phoneAuth: enPhoneAuth,
    saveAccount: enSaveAccount,
    results: enResults,
    clothingSizes: enClothingSizes,
    selfie: enSelfie,
    cacheModal: enCacheModal,
  },
  es: {
    common: esCommon,
    intro: esIntro,
    measurements: esMeasurements,
    phoneAuth: esPhoneAuth,
    saveAccount: esSaveAccount,
    results: esResults,
    clothingSizes: esClothingSizes,
    selfie: esSelfie,
    cacheModal: esCacheModal,
  },
  pt: {
    common: ptCommon,
    intro: ptIntro,
    measurements: ptMeasurements,
    phoneAuth: ptPhoneAuth,
    saveAccount: ptSaveAccount,
    results: ptResults,
    clothingSizes: ptClothingSizes,
    selfie: ptSelfie,
    cacheModal: ptCacheModal,
  },
  it: {
    common: itCommon,
    intro: itIntro,
    measurements: itMeasurements,
    phoneAuth: itPhoneAuth,
    saveAccount: itSaveAccount,
    results: itResults,
    clothingSizes: itClothingSizes,
    selfie: itSelfie,
    cacheModal: itCacheModal,
  },
  zh: {
    common: zhCommon,
    intro: zhIntro,
    measurements: zhMeasurements,
    phoneAuth: zhPhoneAuth,
    saveAccount: zhSaveAccount,
    results: zhResults,
    clothingSizes: zhClothingSizes,
    selfie: zhSelfie,
    cacheModal: zhCacheModal,
  },
  ja: {
    common: jaCommon,
    intro: jaIntro,
    measurements: jaMeasurements,
    phoneAuth: jaPhoneAuth,
    saveAccount: jaSaveAccount,
    results: jaResults,
    clothingSizes: jaClothingSizes,
    selfie: jaSelfie,
    cacheModal: jaCacheModal,
  },
  hi: {
    common: hiCommon,
    intro: hiIntro,
    measurements: hiMeasurements,
    phoneAuth: hiPhoneAuth,
    saveAccount: hiSaveAccount,
    results: hiResults,
    clothingSizes: hiClothingSizes,
    selfie: hiSelfie,
    cacheModal: hiCacheModal,
  },
};

// Liste des langues supportées (drapeaux via flagcdn.com)
export const SUPPORTED_LANGUAGES = [
  { code: 'fr', name: 'Français', flag: 'https://flagcdn.com/w40/fr.png' },
  { code: 'en', name: 'English', flag: 'https://flagcdn.com/w40/gb.png' },
  { code: 'es', name: 'Español', flag: 'https://flagcdn.com/w40/es.png' },
  { code: 'pt', name: 'Português', flag: 'https://flagcdn.com/w40/pt.png' },
  { code: 'it', name: 'Italiano', flag: 'https://flagcdn.com/w40/it.png' },
  { code: 'zh', name: '中文', flag: 'https://flagcdn.com/w40/cn.png' },
  { code: 'ja', name: '日本語', flag: 'https://flagcdn.com/w40/jp.png' },
  { code: 'hi', name: 'हिन्दी', flag: 'https://flagcdn.com/w40/in.png' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en', 'es', 'pt', 'it', 'zh', 'ja', 'hi'],
    defaultNS: 'common',
    ns: ['common', 'intro', 'measurements', 'phoneAuth', 'saveAccount', 'results', 'clothingSizes', 'selfie', 'cacheModal'],

    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'mirror-language',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React gère déjà l'échappement
    },

    react: {
      useSuspense: false, // Désactiver suspense pour compatibilité iframe
    },
  });

export default i18n;
